import CompareFundsModal from './CompareFundsModal'

export default CompareFundsModal
